import { env } from 'core/config/environment';

window.addEventListener('unhandledrejection', (event) => {
  logger.error(event.reason, {
    type: 'unhandled_promise_rejection',
    message: event.reason.message
  });
});

window.onerror = (message, source, lineno, colno, error) => {
  logger.error(error as Error, {
    type: 'global_error',
    location: `${source}:${lineno}:${colno}`,
    message
  });
};

export const logger = {
  error: (error: Error | string | unknown, context = {}) => {
    if (env.STAGE === 'dev') {
      // eslint-disable-next-line no-console
      console.error('[ERROR]', error, context);
    }
    // Here we can send this to a error logging service
  },
  debug: (message: string, context: Record<string, unknown> = {}) => {
    if (env.STAGE === 'dev') {
      // console.log (not console.debug) so it is visible at the default devtools log level.
      // eslint-disable-next-line no-console
      console.log('[DEBUG]', message, context);
    }
  }
};
